import { Row } from '../../../../../coaching-observation/experimental.grid';
import { createAction } from '../../../../../store.model';
import { ActionType } from '../commitment-narrative.action';
import { CellContext, RowContext } from '../commitment-narrative.model';

export interface Reload {
    rows?: Array<Row<RowContext, CellContext>>;
}

export const reload = createAction<ActionType, Reload>(
    ActionType.COMMITMENT_NARRATIVE__RELOAD,
);
